//请自行添加语言资源
const violationRecords = {
  plantName:'基地',
  businessNo: '业务编号',
  vehicleNo:'车牌号',
  driverName:'司机姓名',
  driverTel:'司机电话',
  violationReasonName:'违章原因',
  remark:'备注',
  createTime: '发起日期',
  creator:'发起人',
};
export default violationRecords



// WEBPACK FOOTER //
// ./src/page/report/violationRecords/lang/violationRecords.zh.js